module.exports = __webpack_public_path__ + "img/content-1.194bc3fd.png";